import React, { Component } from "react";

import ChargerTitle from "../chargerInfo/ChargerTitle";

class FavoriteCard extends Component {
  render() {
    return (
      <div id="favoriteCard" className="highlight-container">
        <ChargerTitle
          charger={{ properties: this.props.charger }}
          currentLocation={this.props.currentLocation}
          isFavorite={true}
          toggleFavorite={() => this.props.toggleFavorite("delete", this.props.charger)}
          extended
        />
      </div>
    );
  }
}

export default FavoriteCard;
